import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Row, Col, Card, Spin, Typography } from "antd"
import { getProducts } from "../services/ProductServices"
import "../assets/styles/Categories.css"

const { Title, Text } = Typography

export default function Categories() {
  const [loading, setLoading] = useState(true)
  const [categoriesData, setCategoriesData] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const products = await getProducts()
        
        // Agrupar productos por categoría y contar
        const categoriesMap = {}
        products.forEach((product) => {
          const category = product.category || "Sin categoría"
          if (!categoriesMap[category]) {
            categoriesMap[category] = {
              name: category,
              count: 0
            }
          }
          categoriesMap[category].count++
        })
        
        // Convertir a array y ordenar por cantidad de productos
        const categoriesArray = Object.values(categoriesMap).sort((a, b) => b.count - a.count)
        setCategoriesData(categoriesArray)
      } catch (error) {
        console.error("Error loading categories:", error)
      } finally {
        setLoading(false)
      }
    }

    loadCategories()
  }, [])

  const handleCategoryClick = (category) => {
    navigate(`/?category=${encodeURIComponent(category)}`)
  }

  if (loading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    )
  }

  return (
    <div className="categories-page">
      <div className="categories-header">
        <Title level={1} className="categories-title">
          Categorías de Productos
        </Title>
      </div>
      
      <Row gutter={[24, 24]} justify="start" className="categories-grid">
        {categoriesData.map((categoryData) => (
          <Col xs={24} sm={12} md={8} lg={6} xl={6} key={categoryData.name}>
            <Card 
              className="category-card"  
              onClick={() => handleCategoryClick(categoryData.name)}
              hoverable
            >
              <div className="category-card-content">
                <Title level={4} className="category-name">
                  {categoryData.name}
                </Title>
                <div className="category-badge-container">
                  <Text className="category-count-text">
                    <strong>{categoryData.count}</strong> {categoryData.count === 1 ? 'producto' : 'productos'}
                  </Text>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

